<ng-container *ngIf="proofOfDeliveryItemForm">
  <div class="tw-flex tw-justify-center">
    <div class="tw-basis-full lg:tw-basis-3/5 xl-min:tw-basis-3/5">
      <ng-container *ngIf="isPermissionsApplicable; else buttonsWrap">
        <ng-container *ngTemplateOutlet="buttonsWrapWithPermissions"></ng-container>
      </ng-container>
      <mat-card appearance="outlined">
        <form [formGroup]="proofOfDeliveryItemForm">
          <mat-card-title
            *ngIf="proofOfDeliveryData?.deliveryNoteNumber as deliveryNoteNumber"
            class="tw-flex tw-justify-between"
          >
            <span class="proof-of-delivery__title"
              >{{ 'common.field.deliveryNoteNumber' | translate }}: {{ deliveryNoteNumber }}</span
            >
            <ng-content select="[feedback-button]"></ng-content>
          </mat-card-title>
          <mat-card-title class="tw-flex">
            <span>{{ 'deliveryNote.proofOfDelivery.title' | translate }}</span>
          </mat-card-title>
          <div class="tw-flex tw-gap-x-8">
            <mat-form-field class="tw-basis-full">
              <mat-label>{{ 'common.list.th.type' | translate }}*</mat-label>
              <mat-select
                formControlName="type"
                [disabledControl]="
                  isPermissionsApplicable &&
                  !(
                    authFacade.hasPermission$(
                      permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.create
                    ) | async
                  )
                "
              >
                <mat-option *ngFor="let proofOfDeliveryType of proofOfDeliveryTypeList" [value]="proofOfDeliveryType">
                  {{ 'common.filter.option.' + proofOfDeliveryType.toLowerCase() | translate }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validationService.hasError(proofOfDeliveryItemForm, 'type', 'required')"
                >{{ 'common.validation.error.required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="proofOfDeliveryDocumentsFormArray" formArrayName="documents">
            <div>
              <mat-card-title class="tw-flex">
                <span>{{ 'deliveryNote.proofOfDelivery.podFiles' | translate }}</span>
              </mat-card-title>
              <div *ngFor="let podDocument of proofOfDeliveryDocumentsFormArray.controls; let i = index">
                <div class="tw-flex tw-gap-x-8" [formGroupName]="i">
                  <mat-form-field class="tw-basis-3/4">
                    <mat-label>{{ 'common.field.huNumber' | translate }}*</mat-label>
                    <mat-select
                      formControlName="huNumbers"
                      multiple
                      [disabledControl]="
                        isPermissionsApplicable &&
                        !(
                          authFacade.hasPermission$(
                            permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.create
                          ) | async
                        )
                      "
                    >
                      <mat-option *ngFor="let huNumber of huNumbers" [value]="huNumber">
                        {{ huNumber }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="validationService.hasError(podDocument, 'huNumbers', 'required')"
                      >{{ 'common.validation.error.required' | translate }}
                    </mat-error>
                  </mat-form-field>

                  <div class="document-buttons tw-flex tw-basis-1/4 tw-justify-end tw-items-center">
                    <ng-container
                      *ngVar="proofOfDeliveryDocumentsFormArray.at(i).get('huNumbers').value as huNumbersValue"
                    >
                      <ui-svg-icon
                        *ngIf="isHandlingUnitType && huNumbersValue.length"
                        [name]="iconNameList.AlertInfo"
                        [width]="32"
                        class="delay-info document-buttons__item"
                        [attr.test-id]="'alert-info'"
                        [matTooltip]="huNumbersValue.join('&#13;')"
                      ></ui-svg-icon>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        proofOfDeliveryDocumentsFormArray.at(i).get('content').value ||
                          proofOfDeliveryDocumentsFormArray.at(i).get('documentId').value;
                        else attachProofOfDeliveryFile
                      "
                    >
                      <ui-svg-icon
                        *ngIf="proofOfDeliveryDocumentsFormArray.at(i).get('content').value"
                        class="color-success checkmark document-buttons__item"
                        [name]="iconNameList.Checkmark"
                        [width]="32"
                      ></ui-svg-icon>

                      <ui-svg-icon
                        *ngIf="proofOfDeliveryDocumentsFormArray.at(i).get('documentId').value"
                        class="download-icon pointer document-buttons__item"
                        [name]="iconNameList.DownloadFrame"
                        [width]="32"
                        [attr.test-id]="'download-button'"
                        (click)="
                          downloadFile(
                            proofOfDeliveryDocumentsFormArray.at(i).get('documentId').value,
                            proofOfDeliveryDocumentsFormArray.at(i).get('name').value
                          )
                        "
                      ></ui-svg-icon>
                    </ng-container>

                    <ng-template #attachProofOfDeliveryFile>
                      <ng-container *ngIf="isPermissionsApplicable; else attachFile">
                        <ng-container *ngTemplateOutlet="attachFileWithPermissions"></ng-container>
                      </ng-container>
                      <ng-template #attachFile>
                        <p
                          *ngIf="proofOfDeliveryDocumentsFormArray.at(i)"
                          (click)="fileInput.click()"
                          class="link document-buttons__item"
                        >
                          {{ 'common.button.attachFile' | translate }}<sup>*</sup>
                        </p>
                      </ng-template>

                      <ng-template #attachFileWithPermissions>
                        <ng-container
                          *show="permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.create"
                        >
                          <ng-container *ngTemplateOutlet="attachFile"></ng-container>
                        </ng-container>
                      </ng-template>
                    </ng-template>
                    <input
                      #fileInput
                      hidden
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onclick="value = null"
                      (change)="onAddFile($event.target.files[0], i)"
                    />
                    <ng-container *ngIf="isPermissionsApplicable; else deleteFile">
                      <ng-container *ngTemplateOutlet="deleteFileWithPermissions"></ng-container>
                    </ng-container>
                    <ng-template #deleteFile>
                      <ui-svg-icon
                        class="link document-buttons__item"
                        [name]="iconNameList.Delete"
                        [width]="32"
                        [attr.test-id]="'delete-button'"
                        (click)="deleteProofOfDeliveryDocumentOrFile(i)"
                      ></ui-svg-icon>
                    </ng-template>

                    <ng-template #deleteFileWithPermissions>
                      <ng-container
                        *show="permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.delete"
                      >
                        <ng-container *ngTemplateOutlet="deleteFile"></ng-container>
                      </ng-container>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="isPermissionsApplicable; else addFile">
            <ng-container *ngTemplateOutlet="addFileWithPermissions"></ng-container>
          </ng-container>
          <ng-template #addFile>
            <div class="tw-flex tw-justify-end">
              <p class="link" (click)="addProofOfDeliveryFile()">
                {{ 'common.button.addFile' | translate }}
              </p>
            </div>
          </ng-template>

          <ng-template #addFileWithPermissions>
            <ng-container *show="permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.delete">
              <ng-container *ngTemplateOutlet="addFile"></ng-container>
            </ng-container>
          </ng-template>
        </form>
      </mat-card>
    </div>
  </div>
</ng-container>

<ng-template #buttonsWrap>
  <div class="buttons-wrap tw-flex tw-justify-end tw-gap-x-8">
    <ng-content select="[request-button]"></ng-content>
    <ng-container *ngTemplateOutlet="submitButton"></ng-container>
  </div>
</ng-template>

<ng-template #buttonsWrapWithPermissions>
  <ng-container *show="permissionConfig.TT.automotive_aftermarket.delivery_note.pod_management.create">
    <ng-container *ngTemplateOutlet="buttonsWrap"></ng-container>
  </ng-container>
</ng-template>

<ng-template #submitButton>
  <ui-action-button
    [action]="buttonAction.Save"
    [type]="buttonType.Primary"
    [disabled]="proofOfDeliveryItemForm.invalid || proofOfDeliveryItemForm.pristine"
    (buttonClick)="createOrUpdateProofOfDelivery()"
  ></ui-action-button>
</ng-template>
